webpackJsonp([35783957827783],{

/***/ 164:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 132:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.134f534f.ico";

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(160);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _rekon_logo = __webpack_require__(57);
	
	var _rekon_logo2 = _interopRequireDefault(_rekon_logo);
	
	var _doktrak_logo = __webpack_require__(132);
	
	var _doktrak_logo2 = _interopRequireDefault(_doktrak_logo);
	
	var _favicon = __webpack_require__(54);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	var _favicon3 = __webpack_require__(55);
	
	var _favicon4 = _interopRequireDefault(_favicon3);
	
	var _favicon5 = __webpack_require__(56);
	
	var _favicon6 = _interopRequireDefault(_favicon5);
	
	var _favicon7 = __webpack_require__(333);
	
	var _favicon8 = _interopRequireDefault(_favicon7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Event = function Event(_ref) {
	  var data = _ref.data;
	
	  return !!data.link ? _react2.default.createElement(
	    'a',
	    { href: data.link, className: 'event', target: '_blank', rel: 'noopener noreferrer' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      data.title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'event-venue' },
	      data.venue
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'event-location' },
	      data.location
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'event-sub-location' },
	      data.sub_location
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'event-dates' },
	      data.dates
	    )
	  ) : _react2.default.createElement(
	    'div',
	    { className: 'event' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      data.title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'event-venue' },
	      data.venue
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'event-location' },
	      data.location
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'event-sub-location' },
	      data.sub_location
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'event-dates' },
	      data.dates
	    )
	  );
	};
	var IndexPage = function IndexPage(_ref2) {
	  var data = _ref2.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Rekon Technologies',
	      meta: [{ name: 'description', content: 'Rekon Technologies: Lien Releases. Assignments. Documents. Files. All handled with precision and automation.' }],
	      link: [{ rel: "icon", type: "image/png", sizes: "16x16", href: '' + _favicon2.default }, { rel: "icon", type: "image/png", sizes: "32x32", href: '' + _favicon4.default }, { rel: "shortcut icon", type: "image/png", href: '' + _favicon6.default }, { rel: "shortcut icon", type: "image/x-icon", href: '' + _favicon8.default }]
	    }),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero hero-home is-primary' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body home-body-bg' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'block line-1' },
	            data.pagesYaml.hero.line_1
	          ),
	          _react2.default.createElement(
	            'strong',
	            { className: 'block line-2' },
	            data.pagesYaml.hero.line_2
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'section',
	        { className: 'container is-fullhd has-middle-border product-choice-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns is-mobile is-multiline has-text-centered' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-half-widescreen' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              data.pagesYaml.product_text.rekon_text
	            ),
	            _react2.default.createElement('img', { src: _rekon_logo2.default, alt: 'Rekon Logo' }),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/rekon', className: 'button is-primary is-large' },
	              data.pagesYaml.button_text.to_rekon
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-half-widescreen' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              data.pagesYaml.product_text.doktrak_text
	            ),
	            _react2.default.createElement('img', { src: _doktrak_logo2.default, alt: 'DokTrak Logo' }),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/doktrak', className: 'button is-success is-large' },
	              data.pagesYaml.button_text.to_doktrak
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-default container-testimonials' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body has-text-centered' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'title h2' },
	          data.pagesYaml.testimonial_section.title
	        ),
	        _react2.default.createElement(
	          'blockquote',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            data.pagesYaml.testimonials[0].testimonial
	          ),
	          _react2.default.createElement(
	            'small',
	            null,
	            data.pagesYaml.testimonials[0].testimonee
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero container-upcoming-events' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container is-fullhd' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-5-desktop is-offset-6-desktop' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'title' },
	              'Upcoming Events'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Schedule time to meet us at one of the following events:'
	            ),
	            data.pagesYaml.events.map(function (event, idx) {
	              return _react2.default.createElement(Event, { key: idx, data: event });
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'section',
	        { className: 'container container-alliances' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns is-multiline is-centered' },
	          data.pagesYaml.alliances.map(function (alliance, idx) {
	            return _react2.default.createElement(
	              'div',
	              { key: idx, className: 'column' },
	              _react2.default.createElement('img', {
	                src: ("") + alliance.logo_path,
	                alt: alliance.description,
	                style: {
	                  width: eval(alliance.logo_width * 0.5) + 'px',
	                  height: eval(alliance.logo_height * 0.5) + 'px'
	                } })
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = IndexPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-d702e1961940f4730184.js